<div class="center-xy"
     [ngStyle]="{ overflow: zones.overflow ? 'auto' : 'hidden'}"
     *ngIf="zones.selectedZone">
    <div class="zone-control-wrapper bg-light" data-testid="schedule-zones-list-control">
        <div class="zone-control__top">
            <div class="zone-control__top-icon bg-style bg-style__icon border-light">
                <zone-icon [name]="zones.selectedZone.description.styleIcon" [size]="45"></zone-icon>
            </div>
            <p class="zone-control__top-name font-bold font-24 bg-style bg-style__label color-light">
                {{ zones.getZoneName(zones.selectedZone) }}
            </p>
        </div>
        <div class="zone-control__content">
            <div class="select-zones box-shadow">
                <div class="select-zones__title-top">
                    <input class="schedule__name--input font-18 font-bold"
                           type="text"
                           [(ngModel)]="zoneSchedule.name">
                </div>
                <p class="select-zones__title font-18 font-bold">
                    {{ subtitle(2757) + ':' }}
                </p>
                <div class="select-zones__list">
                    <div class="select-zones__item select-zones__item--all cursor-pointer"
                         (click)="zoneSchedule.selectZone('all')">
                        <div class="select-zones__checkbox border-grey"
                             [ngClass]="{ 'border-zone bg-style': zoneSchedule.selectedAll,
                                'border-gray': !zoneSchedule.selectedAll }">
                            <img ngSrc="/assets/img/zone_icons/checked.svg"
                                 width="24" height="24" alt=""/>
                        </div>
                        <p class="select-zones__name font-18 font-bold">
                            {{ subtitle(2758) }}
                        </p>
                    </div>
                    <div class="select-zones__item"
                         *ngFor="let zone of zoneSchedule.zonesTable; let idx = index"
                         [ngClass]="{ 'cursor-pointer': zone.status !== 'disabled',
                            'cursor-default': zone.status === 'disabled' }"
                         data-testid="zone-item"
                         (click)="zoneSchedule.selectZone(idx)">
                        <div class="select-zones__checkbox"
                             [ngClass]="{ 'border-grey': zone.status === 'empty' || zone.status === 'disabled',
                                'bg-default': zone.status === 'disabled',
                                'border-zone bg-style': zone.status === 'selected' }">
                            <img ngSrc="/assets/img/zone_icons/checked.svg"
                                 data-testid="checked-icon"
                                 *ngIf="zone.status !== 'empty'"
                                 width="24" height="24" alt=""/>
                        </div>
                        <p class="select-zones__name font-18 font-bold">
                            {{ zones.getZoneName(zone) }}
                        </p>
                    </div>
                </div>

                <div class="control__group-btn select-zones__buttons">
                    <button class="control__button bg-cancel bg-cancel__button"
                            data-testid="back-button"
                            (click)="zones.goBack()">
                        <img class="control__button-img zone-control__button-back"
                             ngSrc="/assets/img/zone_icons/back.svg"
                             width="40" height="40" alt=""/>
                    </button>
                    <button class="control__button bg-ok bg-ok--accept"
                            *ngIf="!zoneSchedule.isSendingSchedule"
                            data-testid="send-button"
                            (click)="zoneSchedule.returnSchedule('global_schedule')">
                        <img class="control__button-img"
                             ngSrc="/assets/img/icons/ok.svg"
                             width="40" height="40" alt=""/>
                    </button>
                    <div class="control__button bg-ok bg-ok--accept"
                         *ngIf="zoneSchedule.isSendingSchedule">
                        <loader></loader>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

